import { render } from "./AssistenzaPage.vue?vue&type=template&id=74a6e730"
import script from "./AssistenzaPage.vue?vue&type=script&lang=js"
export * from "./AssistenzaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__